import {createSheetService} from './sheetServiceFactory';

const service = createSheetService('SiteViews', [
  'id',
  'page',
  'created_at',
  'updated_at'
]);

let pageViewPromise = null;

export async function recordPageView() {
  if (pageViewPromise) return pageViewPromise;

  pageViewPromise = (async () => {
    const existingViews = await service.list();
    await service.create({page: '/'});
    return existingViews.length + 1;
  })();

  return pageViewPromise;
}